// extracted by mini-css-extract-plugin
module.exports = {"none":"app-none-033e","app":"app-app-033e","square":"app-square-033e"};